import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/workshop/workshop_business_units`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_business_units/${id}`, options)
    .then(response => {
      let business_units = jsona.deserialize(response.data);
      delete business_units.links;
      return business_units;
    });
}

function add(business_units) {
  
  console.log(business_units);
  const payload = jsona.serialize({
    stuff: business_units,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/workshop/workshop_business_units`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(business_units) {
  const payload = jsona.serialize({
    stuff: business_units,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/workshop/workshop_business_units/${business_units.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {``
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/workshop/workshop_business_units/${id}`, options);
}


export default {
  list,
  get,
  add,
  update,
  destroy
};

